import React, { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import axiosInstance from "../utils/axiosConfig";
import { API_URL } from "../constant";
import { toast } from "react-hot-toast";

const LoginWithOtp = ({ setCodeScreen, setCodeMail, email }: any) => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const signInwithAuthCode = async (email: string) => {
    setLoading(true);
    try {
      await axiosInstance.post(`${API_URL}api/auth/signin/authenticator`, {
        email,
        otp,
        rolePass: "admin",
      });
      toast.success("OTP sent to your email");
      setCodeScreen(true);
    } catch (error: any) {
      toast.error(
        (error?.response?.data?.message as string) ||
          String(error?.message || "Login failed")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    signInwithAuthCode(email);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full lgss:mt-12  mt-12 md:mt-0  "
    >
      <div className="w-full">
        <label className="text-white font-bold text-[14px]">Email</label>
        <input
          type="email"
          value={email}
          placeholder="Enter your email"
          onChange={(e) => setCodeMail(e.target.value.toLowerCase())}
          name="email"
          className="h-[58px] w-full mt-4  px-[16px]  font-manrope border-2 rounded-lg border-gray-500 outline-none bg-transparent  text-[#A0A9AD] transition duration-200"
        />
      </div>
      <div className="w-full mt-8">
        <label className="text-white font-bold text-[14px]">
          Authorization Code
        </label>
        <input
          value={otp}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="Enter 6 digit OTP"
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, ""); // removes non-digits
            setOtp(value);
          }}
          className="h-[58px] w-full mt-4 px-[16px] font-manrope border-2 rounded-lg border-gray-500 outline-none bg-transparent text-[#A0A9AD] transition duration-200"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full h-[63px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-12"
      >
        {loading ? (
          <TailSpin color="#FFFFFF" height={30} width={30} />
        ) : (
          "Login"
        )}
      </button>
    </form>
  );
};

export default LoginWithOtp;
